// Packages
import React, { useEffect } from 'react';
import { useDispatch } from "react-redux";
import { useLocation, Navigate } from 'react-router-dom';

// Auth
import * as authActions from "../../../auth/AuthActions"

export default function LogoutPage(props) {
    let location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(authActions.signOut())
    },[dispatch])

    return (
        <>
            {!props.authorized ?
                <Navigate to="/login" state={{ from: location }} />
                :
                <>
                    <h1> Logout Page </h1>
                </>
            }
        </>
    )
}